import { Model } from "99Tools/useModel";
import { GetDateForLogAPI, TypeKizaiKind } from "99Tools/utils";
import { Auth } from "aws-amplify";

export class Log extends Model {
  public urlSensor = process.env.REACT_APP_URL_SENSORS ?? "";
  public urlPico3 = process.env.REACT_APP_URL_PICO3 ?? "";
  public page = 0;
  public rowsPerPage = 10;
  public logItems = [];
  public kind: TypeKizaiKind = "init";
  public deviceId = "";
  public start = ""; // 日付範囲開始
  public end = ""; // 日付範囲終了
  public errorMessage = "";

  public SetError(err: any, msg: string) {
    this.errorMessage = msg;
    console.log(this.errorMessage);
    console.error(err);
  }

  public async Clear() {
    this.logItems = [];
    this.kind = "init";
    this.deviceId = "";
    this.start = "";
    this.end = "";
    this.page = 0;
  }

  public async GetLog() {
    const range = GetDateForLogAPI(this.start, this.end);
    if (
      this.kind === "init" ||
      this.kind === "error" ||
      !this.deviceId ||
      !range.start ||
      !range.end
    ) {
      this.logItems = [];
      this.changed();
      return;
    }

    if (this.kind === "lte" || this.kind === "subgiga") {
      const log = await this.SensorLog(this.deviceId, range.start, range.end);
      this.logItems = log;
    } else if (this.kind === "pico3") {
      const log = await this.Pico3Log(this.deviceId, range.start, range.end);
      this.logItems = log;
    }
    this.changed();
  }

  private async SensorLog(ID: string, start: string, end: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let log: any = null;
    await fetch(
      `${this.urlSensor}/log/histories/?start=${start}&end=${end}`,
      options
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("センサログ情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        log = data;
      });
    //console.log({log})
    return log.filter((item: any) => item.SensorId === ID);
  }

  private async Pico3Log(ID: string, start: string, end: string) {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    const options: RequestInit = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: token,
      }),
    };
    let log: any = null;
    await fetch(
      `${this.urlPico3}/log/histories/?start=${start}&end=${end}`,
      options
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Pico3ログ情報取得失敗");
        }
        return response.json();
      })
      .then((data) => {
        log = data;
      });
    //console.log({log})
    return log.filter((item: any) => item.PicoId === ID);
  }
}
